export default __webpack_public_path__ + "static/media/012.47df360f.jpg";